module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "edit_wrap"
  }, [_c('div', {
    staticClass: "add_top"
  }, [_c('div', {
    staticClass: "add_tab",
    class: [_vm.isType == 1 ? 'active_tab' : ''],
    on: {
      "click": function($event) {
        _vm.changeTab(1)
      }
    }
  }, [_vm._v("申请大V店已有品牌")]), _vm._v(" "), _c('div', {
    staticClass: "add_tab",
    class: [_vm.isType != 1 ? 'active_tab' : ''],
    on: {
      "click": function($event) {
        _vm.changeTab(2)
      }
    }
  }, [_vm._v("添加新品牌")])]), _vm._v(" "), _c('oldBrand', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isType == 1),
      expression: "isType == 1"
    }]
  }), _vm._v(" "), _c('newBrand', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isType != 1),
      expression: "isType != 1"
    }]
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-128d391c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/info_manage/add_categary_agree/addBrandCommonPages.vue
// module id = 498
// module chunks = 0